import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '@abp/ng.core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    const apiUrl = this.environmentService.getApiUrl('default');
    this.baseUrl = `${apiUrl}`;
  }

  getImage(fileId: number, width?: number, height?: number): Observable<Blob> {
    let url = `${this.baseUrl}/image/${fileId}`;
    if (width && height) {
      url += `?width=${width}&height=${height}`;
    }
    return this.http.get(url, { responseType: 'blob' });
  }

  getFile(fileId: number): Observable<Blob> {
    const url = `${this.baseUrl}/file/${fileId}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
